import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
const PackagingCard = ({
  packagingInfo = {},
  title,
  description,
  price,
  image,
  tag = "",
  onClick,
  link = "",
  state = {},
}) => {
  return (
    <div className="dish-card packaging-optiopn-card">
      <div className="dish-image">
        <img src={image} alt={title} />
      </div>
      <div className="dish-content">
        <div>
          <h4 className="title">{title}</h4>
          <p className="description">{description}</p>
          <div className="price-wrap">
            <p className="price">
              <span className="price">Starting from ₹{price}</span>/piece
            </p>
            <ul className="packaging-options-list">
              {packagingInfo.sizes &&
                packagingInfo.sizes
                  .split(",")
                  .map((size, index) =>
                    !size === "NA" ? <li key={index}>{size.trim()}</li> : <></>
                  )}
            </ul>
            {/* <ul className="packaging-options-list">
              <li>7 inch</li>
              <li>10 inch</li>
            </ul> */}
          </div>
        </div>
        <div className="dish-btn">
          <Link to={`/${link}`} state={state} className="btn btn-orange-light">
            Proceed to Enquire{" "}
            <FontAwesomeIcon icon={faChevronRight} className="right-arrow1" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PackagingCard;
